import { Box } from '@mui/material';
import { Outlet } from '@tanstack/react-router';
import { AppBreadcrumbs } from './AppBreadcrumbs';
import { AppFooter } from './app-shell/AppFooter';
import { DocumentTitle } from './app-shell/DocumentTitle';
import { DocumentFavicon } from './app-shell/DocumentFavicon';
import { MainBackground } from './app-shell/MainBackground';
import { NavigationDrawer } from './app-shell/NavigationDrawer';

export const AppShell = () => (
  <>
    <DocumentTitle />
    <DocumentFavicon />
    <Box sx={{ position: 'relative', display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <MainBackground />
      <NavigationDrawer />
      <Box component="main" sx={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', flexGrow: 1, minWidth: 0, pt: { xs: 10, md: 0 } }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            width: '100%',
            maxWidth: 1440,
            mx: 'auto',
            px: { xs: 2, sm: 3, lg: 5 },
            py: { xs: 3, md: 5 },
          }}
        >
          <AppBreadcrumbs />
          <Box sx={{ flexGrow: 1 }}>
            <Outlet />
          </Box>
          <AppFooter />
        </Box>
      </Box>
    </Box>
  </>
);
